import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
import type { IProduct, IProductComplianceTechnical } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import DoNotDiyStyle from './DoNotDiyStyle.js';

/**
 * Warning sign used on the Australian market to inform that an appliance sold must be installed by a licensed electrician.
 */
export default class DoNotDiy extends KompisElement {
	// A product.
	@property({ type: Object, required: true })
	public product!: IProduct;

	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		const doNotDiyComplianceData = this.getDoNotDiyInfo();
		const svgUrl = doNotDiyComplianceData && this.getSvgUrl(doNotDiyComplianceData);

		if (!svgUrl || !doNotDiyComplianceData) {
			return html`
				<style>
					:host {
						display: none;
					}
				</style>
			`;
		}

		const { text: altText } = doNotDiyComplianceData;

		return html`<style>
				${DoNotDiyStyle.getStyle()}
			</style>

			${this.getImage(svgUrl, altText)} `;
	}

	private getDoNotDiyInfo(): IProductComplianceTechnical | undefined {
		const complianceData = this.product.content?.complianceTechnical?.filter(
			(complianceTechnicalItem) =>
				complianceTechnicalItem.headingType === ProductComplianceTechnicalHeadingTypeEnum.doNotDiy
		);
		return complianceData && complianceData[0];
	}

	private getSvgUrl(complianceInfo: IProductComplianceTechnical): string | null {
		enum MediaEnum {
			svg = '00017'
		}

		const find = (fileTypeCode: MediaEnum): string | null => {
			return (
				complianceInfo.media?.find((mediaType) => mediaType.fileTypeCode === fileTypeCode)?.url ??
				null
			);
		};

		return find(MediaEnum.svg);
	}

	private getImage(svgUrl: string, altText: string): RenderResult {
		return html`<img alt="${altText}" src="${svgUrl}" />`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-do-not-diy': DoNotDiy;
	}
}
